/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOilSupplierDto } from '../models/CreateOilSupplierDto';
import type { CreateOilSupplierEntity } from '../models/CreateOilSupplierEntity';
import type { DeleteOilSupplierEntity } from '../models/DeleteOilSupplierEntity';
import type { GetAllOilSupplierEntity } from '../models/GetAllOilSupplierEntity';
import type { GetAllOilSupplierSimpleEntity } from '../models/GetAllOilSupplierSimpleEntity';
import type { GetDetailOilSupplierEntity } from '../models/GetDetailOilSupplierEntity';
import type { UpdateOilSupplierDto } from '../models/UpdateOilSupplierDto';
import type { UpdateOilSupplierEntity } from '../models/UpdateOilSupplierEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OilSupplierService {

    /**
     * @param search Tìm kiếm theo tên hoặc mô tả
     * @param typeId Lọc theo typeId
     * @param page
     * @param limit
     * @returns GetAllOilSupplierEntity
     * @throws ApiError
     */
    public static oilSupplierControllerGetAll(
        search?: string,
        typeId?: string,
        page: string = '1',
        limit: string = '20',
    ): CancelablePromise<GetAllOilSupplierEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/oil-suppliers',
            query: {
                'search': search,
                'typeId': typeId,
                'page': page,
                'limit': limit,
            },
        });
    }

    /**
     * @param requestBody
     * @returns CreateOilSupplierEntity
     * @throws ApiError
     */
    public static oilSupplierControllerCreate(
        requestBody: CreateOilSupplierDto,
    ): CancelablePromise<CreateOilSupplierEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/oil-suppliers',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns UpdateOilSupplierEntity
     * @throws ApiError
     */
    public static oilSupplierControllerUpdate(
        id: string,
        requestBody: UpdateOilSupplierDto,
    ): CancelablePromise<UpdateOilSupplierEntity> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/oil-suppliers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @returns DeleteOilSupplierEntity
     * @throws ApiError
     */
    public static oilSupplierControllerDelete(
        id: string,
    ): CancelablePromise<DeleteOilSupplierEntity> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/oil-suppliers/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id
     * @returns GetDetailOilSupplierEntity
     * @throws ApiError
     */
    public static oilSupplierControllerGetDetail(
        id: string,
    ): CancelablePromise<GetDetailOilSupplierEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/oil-suppliers/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns GetAllOilSupplierSimpleEntity
     * @throws ApiError
     */
    public static oilSupplierControllerGetAllSimple(): CancelablePromise<GetAllOilSupplierSimpleEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/oil-suppliers/all',
        });
    }

}
